let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("MrUJ0"), load("7Vmxp")]).then(() => parcelRequire('aJWwp'));